<template>
  <div>
    <div class="main" v-if="$store.state.isMobile == 2">
      <div class="top_native">
        <!-- <img class="" src="../../assets/img/ycwhbanner.png" alt="" /> -->
        <img class="" :src="bannerList[0].imgUrl" alt="" />
        <!-- <template v-for="item in bannerList">
          <img class="" :src="item.imgUrl" alt="" />
        </template> -->
        <about_banner style="" v-if="$store.state.editStatus === 0" :type="4" :list="bannerList" @onReturn="bannerDate" />
      </div>
      <!-- 公司简介 -->
      <div class="profile">
        <div class="topTitle" data-wow-delay="1.0s">
          <div class="chinese">公司简介</div>
          <div class="english">COMPANY PROFILE</div>
        </div>
        <div class="detail wow">
          <div class="imgs">
            <!-- <img src="@/assets/img/company.jpg" class=""/> -->
            <img v-if="bannerListMain.length > 0" :src="bannerListMain[0].imgUrl" class="" />
          </div>
          <div class="">
            <p class="message" v-if="bannerListMain.length > 0" v-html="bannerListMain[0].titleMain">
              <!-- 园测信息科技股份有限公司成立于1995年，是国家高新技术企业、江苏省双软认证企业，中国地理信息产业前50强，目前位列第34位。公司具备甲级测绘资质，通过CMMI五级软件成熟度认证、ISO9001质量管理体系认证和ISO27001信息安全管理体系认证，累计获得国家和省部级以上科技进步奖40余项、专利40余项、软件产品及著作权230余项。 -->
              <!-- {{ bannerListMain[0].titleMain }} -->
            </p>
            <!-- <p class="message">
              公司现有员工逾1000名，其中本科以上学历占比超90%，研究生占比40%，设有城市空间智能感知与时空大数据融合创新中心、江苏省地理人工智能工程技术研究中心、苏州市测绘地理信息工程技术研究中心、苏州工业园区博士后科研工作站、武汉大学研究生工作站等。
            </p>
            <p class="message">
              公司成立28年来，全程参与了苏州工业园区“一张蓝图”的绘制与实现，是园区智慧城市建设的长效驱动力，形成了以地理信息技术为核心的，从基础数据采集、大数据分析到智慧化应用的全链条、全生命周期的智慧城市解决方案，涵盖智慧交通、智慧城管、智慧规划、智慧国土、智慧乡镇等各个领域，并在江苏南京、徐州、宿迁、南通，安徽滁州，广西钦州，浙江嘉善，重庆，北京等地设立分子公司，将“园区经验”输出全国。
            </p>
            <p class="message">园测信科以智慧信息构建更美好的城市生活为使命，打造智慧开发区和新型城镇建设领先品牌。
            </p> -->
          </div>
        </div>
        <about_main style="z-index: 500;" v-if="$store.state.editStatus === 0" :type="5" :list="bannerListMain"
          @onReturn="bannerDate"></about_main>
      </div>
      <!-- 企业资质 -->
      <!-- <div class="qualify">
        <div class="topTitle wow animate__animated animate__zoomIn" data-wow-delay="1.0s">
          <div class="chinese">企业资质</div>
          <div class="english">ENTERPRISE QUALIFICATION</div>
        </div>
        <SwiperShow>

          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz1.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz2.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz3.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz4.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz5.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz6.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz7.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz8.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz9.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz9_1.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz9_2.png" />
          </div>

          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz10.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz11.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz12.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/zz/zz13.png" />
          </div>

        </SwiperShow>
        <div class="certList" v-if="false">
          <div class="certType">企业资质：</div>
          <ul>
            <li>国家软件企业</li>
            <li>国家高新技术企业</li>
            <li>IS09001质量管理体系认证</li>
            <li>CCRC信息安全风险评估服务资质</li>
            <li>IS027001信息安全管理体系认证</li>
            <li>CMMIL5软件开发能力成熟度认证</li>
            <li>江苏省重合同守信用单位、省测绘地理信息行业</li>
            <li>诚信单位、质量信得过单位</li>
          </ul>
        </div>
      </div> -->
      <!-- 科研实力 -->
      <!-- <div class="science">
      <div class="topTitle wow animate__animated animate__zoomIn" data-wow-delay="1.0s">
        <div class="chinese">科研实力</div>
        <div class="english">SCIENTIFIC RESEARCH STRENGTH</div>
      </div>
      <SwiperShow>

        <div class="swiper-slide">
          <img src="@/assets/img/classic/zhengshu/ky1.jpg" />
        </div>

        <div class="swiper-slide">
          <img src="@/assets/img/classic/zhengshu/ky2.jpg" />
        </div>
      </SwiperShow>
      <div class="certList" v-if="false">
        <div class="certType">科研实力：</div>
        <ul>
          <li>城市空间智能感知与时空大数据融合创新中心</li>
          <li>江苏省软件企业技术中心</li>
          <li>江苏省地理人工智能工程技术研究中心</li>
          <li>
            江苏省地理空间信息技术工程中心CORS技术<br />工程中心SZCORS分中心
          </li>
          <li>苏州市测绘地理信息工程技术研究中心</li>
          <li>苏州工业园区博士后科研工作站园区测绘分站</li>
          <li>园区测绘一武汉大学研究生工作站</li>
        </ul>
      </div>
    </div> -->
      <!-- 荣誉奖项 -->
      <div class="honor">
        <div class="topTitle wow" data-wow-delay="1.0s">
          <div class="chinese">荣誉奖项</div>
          <div class="english">HONORARY AWRRDS</div>
        </div>
        <SwiperShow class=" animate__animated animate__zoomIn" v-if="bannerListSwiper.length>0">
          <div class="swiper-slide" v-for="item in bannerListSwiper">
            <img :src="item.imgUrl" />
          </div>
          <!-- <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs1.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs2.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs3.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs4.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs5.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs6.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs7.png" />
          </div>

          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs8.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/zs9.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/jx1.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/jx2.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/jx3.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/jx4.png" />
          </div>
          <div class="swiper-slide">
            <img src="@/assets/img/classic/ry/jx5.png" />
          </div> -->

        </SwiperShow>
        <about_swiper style="z-index: 500;" v-if="$store.state.editStatus === 0" :type="8" :list="bannerListSwiper"
          @onReturn="bannerDate"></about_swiper>
        <div class="certList" v-if="false">
          <div class="certType">国家级优秀工程奖：</div>
          <ul>
            <li>苏州市“多规合一”空间规划信息平台</li>
            <li>苏州工业园区智慧不动产综合管理与应用平台</li>
            <li>苏州工业园区商品房住宅小区排水管网普查与检测</li>
            <li>苏州工业园区“房地一张图”综合管理与应用平台</li>
            <li>苏州高新区地理信息公共服务平台</li>
          </ul>
        </div>
      </div>
      <!-- 企业内刊 -->
      <div class="science">
        <div class="topTitle wow animate__animated animate__zoomIn" data-wow-delay="1.0s">
          <div class="chinese">企业内刊</div>
          <div class="english">ENTERPRISE INTERNAL JOURNAL</div>
        </div>
        <!-- <div class="swiperImg">
        <BaseSwiper :speed="2" :direction="'left'" />
      </div> -->
        <SwiperShow class="" v-if="bannerListSwiper1.length>0">
          <div class="swiper-slide swiperBack" v-for="item in bannerListSwiper1" @click="openPdf(item.link)">
            <viewer class="viewerBox" :images="[item.imgUrl]" >
              <img :src="item.imgUrl" />
            </viewer>
          </div>
          <!-- <div class="swiper-slide swiperBack">
            <viewer class="viewerBox" :images="['swip/1.png']">
              <img src="swip/1.png" />
            </viewer>
          </div>
          <div class="swiper-slide swiperBack">
            <viewer class="viewerBox" :images="['swip/2.png']">
              <img src="swip/2.png" />
            </viewer>
          </div>
          <div class="swiper-slide swiperBack">
            <viewer class="viewerBox" :images="['swip/3.png']">
              <img src="swip/3.png" />
            </viewer>
          </div> -->
        </SwiperShow>
        <about_swiper1 style="z-index: 500;" v-if="$store.state.editStatus === 0" :type="10" :list="bannerListSwiper1"
          @onReturn="bannerDate"></about_swiper1>
      </div>
      <!-- 使命愿景 -->
      <div class="culture example animate__animated animate__zoomIn">
        <div class="topTitle" data-wow-delay="1.0s">
          <div class="chinese">使命愿景</div>
          <div class="english">MISSION VISION</div>
        </div>
        <div class="example" :style="{ transform: 'translateX(' + offset + 'px)' }">
          <div v-for="item in bannerListVision" class="exampleMain">
            <!-- <img src="@/assets/img/classic/culture_item.png" />
            <h2>使命</h2>
            <p>以智慧信息构建更美好的城市生活</p>    -->
            <img :src="item.imgUrl" />
            <h2>{{ item.titleMain }}</h2>
            <p class="pText" v-html="item.titleAssistant">
              <!-- {{ item.titleAssistant }} -->
            </p>
          </div>
          <!-- <div>
            <img src="@/assets/img/classic/culture_item2.png" />
            <h2>愿景</h2>
            <p>智慧城市整体解决方案提供商</p>
            <p>智慧开发区和新型城镇建设领先品牌</p>
          </div>
          <div>
            <img src="@/assets/img/classic/culture_item3.png" />
            <h2>核心价值观</h2>
            <p>客户至上 贡献为荣 求真务实 合作共赢</p>
          </div> -->

        </div>
        <about_vision style="z-index: 5000000;" v-if="$store.state.editStatus === 0" :type="9" :list="bannerListVision"
          @onReturn="bannerDate"></about_vision>
      </div>
      <!-- 党员干部作风 -->
      <div class="partyMember animate__animated animate__zoomIn">

        <div class="topTitle wow " data-wow-delay="1.0s">
          <div class="chinese">十要十禁</div>
          <div class="english">TEN POINTS TEN PROSCRIPTIONS</div>
        </div>
        <div class="mCont">
          <div class="list ">
            <div class="itemTen" v-for="(item, index) in bannerListTable.slice(0, 5)" :key="index">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <span>0{{ index + 1 }}</span>
              <!-- <p>要共启愿景，禁舍本逐末。</p> -->
              <p>{{ item.keyName }}</p>
            </div>
            <!-- <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <span>02</span>
              <p>要客户导向，禁被动应付。</p>
            </div>
            <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <span>03</span>
              <p>要清廉正直，禁自私自利。</p>
            </div>
            <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <span>04</span>
              <p>要勇于担责，禁推诿扯皮。</p>
            </div>
            <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <span>05</span>
              <p>要求真务实，禁弄虚作假。</p>
            </div> -->
          </div>
          <div class="list right">
            <div class="itemTen" v-for="(item, index) in bannerListTable.slice(5, 10)" :key="index">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <!-- <p>要体系闭环，禁有始无终。</p> -->
              <p>{{ item.keyName }}</p>
              <span>{{ index == 4 ?  Number(index + 6) : '0' + Number(index + 6) }}</span>
            </div>
            <!-- <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <p> 要追求卓越，禁安于现状。</p>
              <span>07</span>
            </div>
            <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <p>要开拓创新，禁因循守旧。</p>
              <span>08</span>
            </div>
            <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <p>要高效执行，禁敷衍拖拉。</p>
              <span>09</span>
            </div>
            <div class="itemTen">
              <img src="@/assets/img/classic/ten10_base.png" alt="">
              <p>要顾全大局，禁各行其是。</p>
              <span>10</span>
            </div> -->
          </div>

        </div>
        <about_list style="z-index: 5000000;" v-if="$store.state.editStatus === 0" :list="bannerListTable"
          @onReturn="bannerDate"></about_list>
      </div>
      <CopyRight></CopyRight>
    </div>
    <MobileAlout v-else />
  </div>
</template>

<script>
import SwiperShow from "../../components/SwiperShow.vue";
import Map from "../components/Map.vue";
import companyData from "@/assets/companyData.json";
import BaseSwiper from "../components/baseSwiper.vue"
import MobileAlout from "../mobile/mobileAbout.vue"
import { banner } from "@/api/public"
import { addCommonData, getCommonDataList } from "@/api/news"
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
export default {
  name: "About",
  components: {
    SwiperShow,
    Map,
    BaseSwiper,
    MobileAlout
  },
  data() {
    return {
      bannerList: [],
      bannerListMain: [],
      bannerListSwiper: [],
      bannerListSwiper1: [],
      bannerListVision: [],
      bannerListTable: [],
      bannerListTable1: [],
      bannerListTable2: [],
      offset: 0, // 初始偏移量
      currentIndex: 0, // 当前索引
      itemWidth: 200, // 每个轮播项的宽度
      interval: null // 定时器
    };
  },
  created() {
      this.initialise()
  },
  mounted() {
    // window.scrollTo(0, 0);
    this.$wow.init();
    // setTimeout(() => {
    //   this.swiperInit()
    // }, 600)
    //轮播
    this.startCarousel();
  },
  methods: {
    openPdf(item){
      // console.log(item,'open')
      window.open(item)
    },
    startCarousel() {
      this.interval = setInterval(() => {
        if (this.bannerListVision.length > 4) {
          this.currentIndex = (this.currentIndex + 1) % this.bannerListVision.length;
          this.offset = 250;
          this.offset = -this.currentIndex * this.itemWidth;
          if (this.currentIndex === 0) {
            // 当轮播到最后一张图时，重置偏移量和当前索引
            this.offset = 250;
            this.currentIndex = 0;
          }
        } else {
          this.offset = 0;
          this.currentIndex = 0;
        }
      }, 3000); // 每3秒切换一次
    },
    beforeDestroy() {
      clearInterval(this.interval); // 组件销毁时清除定时器
    },
    swiperInit() {
      //初始化swiper
      var mySwiper = new Swiper(".swiper-container", {
        direction: "horizontal",
        loop: true,
        // 两遍显示相邻两张
        slidesPerView: "auto",
        spaceBetween: -200,
        // swiper动态加载
        observer: true,
        observeParents: true,
        effect: "coverflow", //slide的切换效果，默认为"slide"（位移切换），可设置为"fade"（淡入）"cube"（方块）"coverflow"（3d流）"flip"（3d翻转）。
        coverflow: {
          rotate: 16, //slide做3d旋转时Y轴的旋转角度.默认50
          stretch: 30, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
          depth: 60, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
          modifier: 2,
          slideShadows: true, //开启slide阴影。默认 true。
        },
        // 当前页居中显示
        centeredSlides: true,
        // 第一张和最后一张贴合边缘
        centeredSlidesBounds: true,

        // 如果需要分页器
        pagination: ".swiper-pagination",
        // 如果需要前进后退按钮
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
      });
    },
    initialise(event) {
      let whileData = '0'
      if (event) {
        whileData = event
      }
      // banner
      if (this.$store.state.isMobile == 2) {
        if (whileData == '0' || whileData == '1') {
          banner({ isRelease: this.$store.state.editStatus, type: 4 }).then(res => {
            this.bannerList = res.data;
            if (res.data.length > 0) {
              setTimeout(() => {
                document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
              }, 100);
              this.$forceUpdate()
            }
          })

        }
        // 公司简介
        if (whileData == '0' || whileData == '2') {
          // 公司简介
          banner({ isRelease: this.$store.state.editStatus, type: 5 }).then(res => {
            this.bannerListMain = res.data;
            if (this.bannerListMain.length > 0) {
              // this.bannerListMain[0].titleMain = this.bannerListMain[0].titleMain.replace(/^<p>(.*)<\/p>$/, "$1")
              this.$forceUpdate()
            }
            if (this.bannerListMain.length > 0) {
              // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerListMain[0].imgUrl})`;
            }
          })
        }
        // 荣誉奖项
        if (whileData == '0' || whileData == '3') {
          // 公司简介
          banner({ isRelease: this.$store.state.editStatus, type: 8 }).then(res => {
            this.bannerListSwiper = res.data;
            this.$forceUpdate()
            if (this.bannerListMain.length > 0) {
              // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerListMain[0].imgUrl})`;
            }
          })
        }
        // 企业内刊
        if (whileData == '0' || whileData == '4') {
          banner({ isRelease: this.$store.state.editStatus, type: 10 }).then(res => {
            this.bannerListSwiper1 = res.data;

            this.$forceUpdate()
            if (this.bannerList.length > 0) {
              // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
            }
          })
        }
        // 使命愿景
        if (whileData == '0' || whileData == '5') {
          banner({ isRelease: this.$store.state.editStatus, type: 9 }).then(res => {
            this.bannerListVision = res.data;
            if (this.bannerListVision.length > 0) {
              // console.log(this.bannerListVision, 'es')
              this.bannerListVision.map(item => {
                item.titleAssistant = item.titleAssistant.replace(/^<h5>(.*)<\/h5>$/, "$1")
                item.titleMain = item.titleMain.replace(/^<h3>(.*)<\/h3>$/, "$1")
              });
            }
            this.$forceUpdate()
            if (this.bannerList.length > 0) {
              // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
            }
          })
        }
        // 十要十禁
        if (whileData == '0' || whileData == '6') {
          getCommonDataList({ isRelease: this.$store.state.editStatus, commonData: 'ten_points_ten_proscriptions' }).then(res => {
            this.bannerListTable = res.data;
            // console.log('shiyaoshijing', this.bannerListTable)
            this.$forceUpdate()
            if (this.bannerList.length > 0) {
              // document.querySelector('.top_native').style.backgroundImage = `url(${this.bannerList[0].imgUrl})`;
            }
          })
        }
        // this.tableData = [];
        // getCommonDataList({ commonData: 'information', isRelease: this.$store.state.editStatus }).then(res => {
        //   this.tableData = res.data;
        //   this.active_index = res.data[0].keyValue
        //   this.pageNum = 1;
        //   this.listData = [];
        //   this.getList();
        // })
        // console.log(this.$route.query.type);
        if (this.$route.query.type == "market") {
          this.active_index = 0;
        } else if (this.$route.query.type == "activity") {
          this.active_index = 1;
        }
      }
    },
    showImagePreview(url) {
      const image = new Image();
      image.src = url;
      image.onload = () => {
        // 创建弹出层
        const previewContainer = document.createElement('div');
        previewContainer.style.position = 'fixed';
        previewContainer.style.top = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.right = 0;
        previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
        previewContainer.style.display = 'flex';
        previewContainer.style.justifyContent = 'center';
        previewContainer.style.alignItems = 'center';
        previewContainer.style.zIndex = 9999;
        document.body.appendChild(previewContainer);
        // 在弹出层中添加图片
        const previewImage = document.createElement('img');
        previewImage.src = url;
        previewImage.style.maxWidth = '80%';
        previewImage.style.maxHeight = '80%';
        previewContainer.appendChild(previewImage);
        // 点击弹出层，关闭预览
        previewContainer.addEventListener('click', () => {
          document.body.removeChild(previewContainer);
        });
      };
    },
    bannerDate(v, e) {
      switch (e) {
        case e == '1':
          this.bannerList = JSON.parse(JSON.stringify(v))
          break;
        case e == '2':
          this.bannerListMain = JSON.parse(JSON.stringify(v))
          break;
        case e == '3':
          this.bannerListSwiper = JSON.parse(JSON.stringify(v))
          break;
        case e == '4':
          this.bannerListSwiper1 = JSON.parse(JSON.stringify(v))
          break;
        case e == '5':
          this.bannerListVision = JSON.parse(JSON.stringify(v))
          break;
        case e == '6':
          this.bannerListTable = JSON.parse(JSON.stringify(v))
          break;
      }
      this.initialise(e)
      this.$forceUpdate()
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style.css";

.main {
  margin-top: 60px;
  text-align: center;

  >div {
    width: 100%;
    background-size: cover;
  }
}

.topTitle {
  color: #044095;
  // padding: 30px;
  padding: 60px;
}

.top_native {
  // height: 856px;
  height: calc(100vh - 60px);
  width: 100%;
  // background: url(../../assets/img/classic/back.jpg) no-repeat center;

  img {
    width: 100%;
    height: 100%;
  }
}

.profile {
  // height: 680px;
  height: 780px;
  background: url(../../assets/img/classic/profile_bg.png) no-repeat center;

  .detail {
    display: flex;
    justify-content: center;

    .imgs {
      width: 700px;

      img {
        width: 100%;
      }
    }

    .message {
      width: 736px;
      color: #828894;
      line-height: 34px;
      text-align: left;
      margin: 10px 40px;
      text-indent: 2em;
    }
  }
}

.certList {
  position: absolute;
  top: 150px;
  left: 50%;
  text-align: left;

  .certType {
    font-size: 20px;
    font-weight: 600;
  }

  ul {
    font-size: 16px;
    margin-left: 50px;
    line-height: 25px;
    margin-top: 10px;
  }
}

.qualify {
  // height: 672px;
  height: 772px;
  // background: url(../../assets/img/classic/qualify_bg.jpg) no-repeat center;
  position: relative;

  .swiper-container {
    // margin-left: 200px;
  }
}

.science {
  // height: 672px;
  height: 772px;
  // background: url(../../assets/img/classic/science_bg.jpg) no-repeat center;
  background-color: #ebf3fb;
  position: relative;

  .swiper-container {
    // margin-right: 200px;
  }

  .certList {
    left: 590px;
  }
}

.honor {
  // height: 672px;
  height: 772px;
  // background: url(../../assets/img/classic/honor_bg.jpg) no-repeat center;
  position: relative;

  .swiper-container {
    // margin-left: 200px;
  }
}

.culture {
  // height: 732px;
  height: 832px;
  background: url(../../assets/img/classic/culture_bg.jpg) no-repeat center;

  .example {
    display: flex;
    justify-content: space-around;
    margin: 0 160px;
    transition: transform 0.5s ease;

    /* 使用transition实现平滑的切换效果 */
    >div {
      margin: 20px;
    }
    .exampleMain{
      width: 550px;
      text-align: center;
    }
    img {
      width: 414px;
      height: 316px;
      overflow: hidden;
    }

    h2 {
      margin: 10px;
    }

    .pText {
      line-height: 25px;
      color: #828894;
      text-align: center !important;
      font-size: 20px;
    }

  }
}

.partyMember {
  // height: 1080px;
  height: 100vh;
  background: url(../../assets/img/classic/ten10_bg.png) no-repeat center;

  .mCont {
    display: flex;
    justify-content: space-around;



    .list {
      .itemTen {
        position: relative;
        width: 483px;
        line-height: 56px;
        margin-bottom: 72px;
        display: flex;
        justify-content: space-between;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }

        text-align: left;

        span,
        p {
          position: relative;
          z-index: 9;
        }

        span {
          width: 37px;
          font-size: 35px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #ffffff;
          padding-left: 30px;
        }

        p {
          display: inline-block;
          font-size: 23px;
          font-family: Source Han Sans CN;
          color: #072142;
          padding-right: 70px;
        }
      }
    }

    .right {
      margin-left: 460px;

      .itemTen {
        img {
          transform: rotateY(180deg);
        }

        span {
          padding: 0;
          padding-right: 30px;
        }

        p {
          padding: 0;
          padding-left: 30px;
        }
      }
    }
  }


}

.swiperImg {
  height: 380px;
}

.swiperBack {
  img {
    width: 100% !important;
  }
}
</style>
